import { useContext } from "react";

import FirebaseContext from "contexts/firebase";
import { UseFirebase } from "interfaces/hooks";

export const useFirebase: UseFirebase = () => {
  return useContext(FirebaseContext);
};
